import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class MotionSensorIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 154.61 300">
                <g fill={color}>
                    <path d="M155.82 300H7.28A7.28 7.28 0 0 1 0 292.72V7.28A7.28 7.28 0 0 1 7.28 0h148.54a7.28 7.28 0 0 1 7.28 7.28v285.44a7.28 7.28 0 0 1-7.28 7.28zM14.55 285.44h134V14.56h-134z" />
                    <path d="M133.55 257.28h-104a7.28 7.28 0 0 1-7.32-7.28v-91.26a7.28 7.28 0 0 1 7.32-7.28h104a7.28 7.28 0 0 1 7.28 7.28V250a7.28 7.28 0 0 1-7.28 7.28zm-96.8-14.56h89.52V166H36.79zm63.74-174.28V82H62.61V68.44h37.87m0-14.56H62.61a14.56 14.56 0 0 0-14.56 14.56V82a14.56 14.56 0 0 0 14.56 14.6h37.87A14.56 14.56 0 0 0 115.05 82V68.44a14.56 14.56 0 0 0-14.56-14.56z" />
                </g>
            </svg>
        );
    }
}

export default withTheme(MotionSensorIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/MotionSensorIcon.js